export default "/_next/static/fonts/IntercomBrush-Small-7771b9f870c00c1c502f6bea7df12ce6.woff";